import { useState } from 'react';

import placeholder from '@/assets/images/avatar-placeholder.svg';
import { cn } from '@/lib/utils/cn';

interface AvatarProps {
  name: string;
  src?: string | null;
  className?: string;
}

/** Image de repli sans contour intégré : les arrondis et la bordure sont gérés uniquement en CSS. */
export const Avatar = ({ name, src, className }: AvatarProps) => {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const imageSrc = src && src !== failedSrc ? src : placeholder;

  return (
    <img
      src={imageSrc}
      alt={name}
      title={name}
      width={36}
      height={36}
      loading="lazy"
      onError={src && imageSrc !== placeholder ? () => setFailedSrc(src) : undefined}
      className={cn(
        'border-navy-200/70 bg-navy-50 size-9 shrink-0 rounded-full border object-cover shadow-[0_2px_4px_-2px_rgb(15_42_95/0.16)]',
        className,
      )}
    />
  );
};
